import { useNavigate } from "react-router-dom";
import FooterSection from "./layouts/Footer";
import HeaderSection from "./layouts/Header";
import { jwtDecode } from "jwt-decode";
import BaseUrl from "../utils/BaseUrl";
import { useEffect } from "react";

const url = BaseUrl();
function ContentPage({children}){
  const token = localStorage.getItem('_token_') !== null ? localStorage.getItem('_token_') : null;
  const exp = token !== null ? jwtDecode(token).exp : null;
  const isExpired =exp !==null ? new Date() > new Date(exp * 1000) : true;
  const navigate = useNavigate();

  useEffect(()=>{

    if(isExpired){ 
        localStorage.removeItem('_token_');
        navigate('/auth');
    }

},[isExpired]);
    return (
        <>
    <div class="container-scroller" >

      {/* Header page */}
      <HeaderSection />
 
      <div class="container-fluid page-body-wrapper" style={{backgroundColor:"#FFC300"}}>
        <div class="main-panel">
          <div class="content-wrapper">

            {children}

          </div>

         {/* Footer page */}

         <FooterSection />
        </div>
      </div>
    </div>
        </>
    );
}

export default ContentPage;